import styled from 'styled-components';
import { HiOutlinePaperClip } from 'react-icons/hi';

const StyledBsPaperclip = styled(HiOutlinePaperClip)`
    font-size: 24px;
`;

export default StyledBsPaperclip;
